// Link to Reetam's document: https://docs.google.com/document/d/1Heme95geyTnNuAhsTfmtlvsamruQPcxO69rr-jhAnqQ/edit#

export const resourcesDetails = {
  riCvcp: {
    title: "RI CVCP",
    website:
      "http://treasury.ri.gov/programs/crime-victim-compensation-program/",
    number: "(401) 462-7650",
  },
  hivAidsresources: {
    title: "HIV and AIDS Resources",

    name: "AIDS Care Ocean State (ACOS)",
    number: "(401) 781-0665",
    location: "Providence",
    website: "http://www.aidscareos.org/",

    name2: "Crossroads RI",
    number2: "(401) 521-2255",
    location2: "Providence",
    website2: "https://www.crossroadsri.org/",

    name3: "Cranston Community Action Partnership (CCAP)",
    number3: "(401) 943-1981",
    location3: "Cranston",
    website3: "https://www.comcap.org/",

    name4: "Northwest Community Health Services",
    number4: "(401) 568-7661",
    location4: "Pascoag",
    website4: "https://www.nch.org/doctors/",

    name5: "RI HIV/AIDS Hotline",
    number5: "(800) 726-3010",

    name6: "Progreso Latino",
    number6: "(401) 728-5920",
    location6: "Central Falls",
    website6: "https://progresolatino.org/",

    name7: "Thundermist Health Center of South County",
    number7: "(401) 783-0523",
    location7: "Wakefield",

    name8: "Visiting Nurse Home & Hospice",
    number8: "(401) 849-2101",
    location8: "Newport",
    website8: "https://visitingnursehh.org/",

    name9: "Youth Pride",
    number9: "(401) 421-5626",
    website9: "https://www.youthprideri.org/",
  },
  dayOne: {
    title: "Day One",
    website: "https://www.dayoneri.org/",
    number: "1 800 494 8100",
  },
  sojournerHouse: {
    title: "Sojourner House: Free Shelter, Counseling, Housing",
    website: "http://www.sojournerri.org/",
    number: "401-765-3232",
  },
  elizabaethBuffamChase: {
    title: "Elizabeth Buffam Chase: Free Shelter and Trained Clinician",
    website: "https://www.ebccenter.org/residential-services",
    number: "Hotline: (401)738-1700",
  },
  riChildrenAdvocacyCenter: {
    title:
      "RI Children Advocacy Center: Child Trauma-Informed Forensic Interview for Legal Case",
    website: "https://www.dayoneri.org/childrens-advocacy-center",
    number: "401-421-4100 119",
  },
  nationalDomesticViolenceHotline: {
    title: "National Domestic Violence Hotline: RI Specific Hotline",
    website: "http://www.HelplineRI.com",
    number: "1-800–494-8100",
  },
  nationalResourceCenterOnDomesticViolence: {
    title: "National Resource Center On Domestic Violence",
    website: "http://www.nrcdv.org/",
    number: "(800) 799-7233",
  },
  officeForVictimsOfCrime: {
    title: "Office For Victims Of Crime",
    website: "https://ovc.ojp.gov/help-for-victims/overview",
    number: "(800) 363-0441",
  },
  leaAndCourtAdvocateInfo: {
    title:
      "LEA and Court Advocate: Free Legal Advocate & Guidance for Police Report",
    name: "Barrington/Bristol/Tiverton/Warren",
    number: "(401) 236-8358",
    name2: "Burrillville/Foster/Glocester/Scituate",
    number2: "(401) 568-9494 ext.7",
    name3: "Central Falls/Cumberland/Lincoln",
    number3: "(401) 612-4088",
    name4: "Charlestown/Hopkinton/Richmond/Westerly",
    number4: "(401) 348-6125",
    name5: "Coventry/East Greenwich/West Greenwich",
    number5: "(401) 826-8915",
    name6: "Cranston",
    number6: "(401) 477-5040",
    name7: "East Providence",
    number7: "(401) 331-1350 x3142",
    name8: "Johnston",
    number8: "(401) 757-3139",
    name9: "Narragansett/North Kingstown/South Kingstown/Jamestown",
    number9: "(401) 294-3316 x8160",
    name10: "Newport/Middletown/Portsmouth",
    number10: "(401) 845-5732",
    name11: "North Providence",
    number11: "(401) 231-4533 x145",
    name12: "Pawtucket",
    number12: "(401) 727-9100 x783",
    name13: "Providence",
    number13: "(401) 243-6338",
    name14: "Providence 2",
    number14: "(401) 243-6334",
    name15: "Warwick",
    number15: "(401) 468-4372",
    name16: "West Warwick",
    number16: "(401) 821-4323 x1140",
    name17: "Woonsocket/Smithfield/North Smithfield",
    number17: "(401) 766-3628",
    name18: "RI State Police",
    number18: "(401) 444-1035	",
  },
  vineCrimeVictimAdvocate: {
    title: "Vine Crime Victim Advocate",
    website: "www.vinelink.com",
    number: "(401) 462-5203",
  },
  dcyf: {
    title: "DCYF Info: Resource if child Witnessed/Experienced Abuse",
    website: "http://www.dcyf.ri.gov/",
    number: "(401) 528-3500",
  },
  nationalCenterForVictimsOfCrime: {
    title: "National Center For Victims Of Crime",
    website: "https://victimsofcrime.org/",
    number: "(800) FYI-CALL",
  },

  bradleyHospitalAndTidesFamilyService: {
    title: "Bradley Hospital And Tides Family Service: Free Therapy for Minors",
    website: "https://www.bradleyhospital.org/parents-and-caregivers",
    number: "401-444-3500",
  },
  familyServicesOfRiAndFamilyCommunityCarePartnership: {
    title:
      "Family Services Of RI And Family Community Care Partnership: Free Therapy for Families with Children",
    website: "https://www.familyserviceri.org/counseling",
    number: "(401) 331-1350",
  },
  dvPartnersUnderRICADVAndCounselingResources: {
    title: "DV Partners Under RI CADV and Counseling Resources",
    name: "Blackstone Valley Advocacy Center (BVAC)",
    details: "Women & Children",
    number: "(401) 723-3057",
    name2: "Domestic Violence Resource Center of South County (DVRCSC)",
    number2: "800.494.8100",
    name3: "Elizabeth Buffum Chace Center (EBCC)",
    number3: "Hotline: (401)738-1700",
    name4: "Women's Resource Center (WRC)",
    number4: "Shelter: 1-800-494-8100",
    name5: "Emergency Housing - Min 6 months, max twenty four months",
    number5: "401-846-5263",
  },
  TRO: {
    title: "Protective/Restraining Orders",
    website: "http://www.ricadv.org/en/restraining-orders",
  },
  undocumentedInfo: {
    title: "Undocumented Resources",
    name: "Sojourner House",
    address: "386 Smith Street, Providence, RI 02908",
    number: "(401) 861-6191​",
    name2: "Progreso Latino",
    address2: "626 Broad Street, Central Falls, RI 02863",
    number2: "(401) 728-5920",
    name3: "Diocese of Providence",
    details3: "Office of Community Services and Advocacy",
    address3: "One Cathedral Square, Providence, RI 02903",
    number3: "(401) 421-7833",
    name4: "Dorcas International Institute of Rhode Island",
    address4: "645 Elmwood Avenue, Providence, RI 02907",
    number4: "(401) 461-5940",
  },
  trafickingSurvivorResources: {
    title: "Traficking Survivors Resources",
    name: "Covenant House - For Homeless & Trafficked Youth",
    number: "(800) 388-3888 24-hr",
    name2: "Get Free lawyer near you",
    website2: "https://www.lsc.gov/grants-grantee-resources/our-grantees",
    name3: "Freedom Network:",
    website3:
      "https://freedomnetworkusa.org/advocacy/survivor-reentry-project/professional-form/",
    website3_2:
      "https://freedomnetworkusa.org/advocacy/survivor-reentry-project/survivor-form/",
    name4:
      "Other crisis lines that can provide assistance to victims of human trafficking include",
    number4: "American Pregnancy Helpline: 866–942–6466",
    number4_2: "GLBT National Youth Talkline: 800–246–7743",
    number4_3: "National Domestic Violence Hotline: 800–799–7233",
    number4_4: "National Runaway Safeline: 800–786–2929",
    number4_5: "National Sexual Assault Hotline: 800–655–4673",
    number4_6: "Planned Parenthood: 800–230–7743",
    number4_7: "Suicide Prevention Lifeline: 800–273–8255",
  },
  legalCounselingRestitutionLink: {
    title: "Legal Counseling Restitution",
    name: "Court Appointed Special Advocate",
    number: "(401) 458-3330",
    name2: "RI Legal Services",
    number2: "(401) 274-2652 ext. 145",
    info2: "Domestic Violence Unit",
    info2_2: "Litigation, negotiations, advice",
    name3: "RI Legal Services (Newport Office)",
    number3: "(401) 846-2264",
    name4: "RI Bar Association",
    info4: "Lawyer referral service",
    number4: "(401) 421-7799",
    website4: "https://ribar.com/",
    info4_2:
      "Reduced fee and legal assistance for those with qualifying income",
  },
  legalAssistanceResources: {
    title: "Legal Counseling Restitution",
    name: "CASA",
    number: "(401) 458-3330",
    info: "Court Appointed Special Advocate",
    name2: "Rhode Island Legal Services",
    number2: "(401) 274-2652 ext. 145",
    info2: "Domestic Violence Unit",
    info2_2: "Litigation, negotiations, advice",
    name3: "Rhode Island Legal Services (Newport Office)",
    number3: "(401) 846-2264",
    name4: "Rhode Island Bar Association",
    info4: "Lawyer Referral Service",
    number4: "(401) 421-7799",
    info4_2:
      "Reduced fee and legal assistance for those with qualifying income",
  },
  victimbarLink: {
    title: "Victim Bar Link",
    info:
      "If you want an attorney to sue the offender through a CIVIL case (different from criminal case)",
    info2: "Only have to pay lawyer if you win",
    website: "https://victimbar.org/attorney-referral-request-form/",
  },
  volunteerLawyerProgram: {
    title: "Volunteer Lawyer Program (for low income individuals)",
    number: "(800) 339-7758",
  },
  homelessnessResources: {
    title: "Homelessness Resources",
    info: "Emergency shelters if homeless",
    name2: "Amos House",
    number2: "Day calls (401) 272-0220",
    website2: "https://amoshouse.com/",
    name3: "Blackstone Valley Advocacy Center (Women & Children)",
    number3: "(401) 723-3057",
    website3: "https://www.bvadvocacycenter.org/en/",
    name4: "Crossroads Rhode Island",
    number4: "(401) 521-2255 Helpline",
    number4_2: "(401 294-7723 x4 North Kingstown Housing",
    number4_3: "(401) 277-4316",
    email4: "cesteam@crossroadsri.org",
    name5: "New Hope Emergency Shelter for Pawtucket/Central Falls (Families)",
    number5: "(401) 728-8490",
    name6: "Interim House",
    number6: "(401) 831-4570",
    name7: "Lucy’s Hearth (Middletown; Women & Children)",
    website7: "https://www.lucyshearth.org/",
    number7: "(401) 847-2021",
    name8: "McKinney Cooperative Shelter (Newport; Men & Women)",
    number8: "(401) 846-6385",
    name9: "Urban League Shelter",
    number9: "(401) 861-9112",
    name10: "RI Family Shelter",
    number10: "(401) 739-8584",
    name11: "Stopover Services of Newport County",
    info11:
      "Short-term crisis intervention, short-term shelter placement for teens",
    number11: "(401) 848-0758",
    name12: "Woonsocket Shelter",
    number12: "(401) 767-0866",
    name13: "Covenant House - For Homeless & Trafficked Youth",
    website13: "https://www.covenanthouse.org/",
    number13: "(800) 388-3888 24-hr",
  },
  helplineRI: {
    title: "Helpline Ri",
    website: "https://www.helplineri.com/resources",
  },
  CAP: {
    title: "Community Action Association",
    website: "https://www.ricommunityaction.org/",
    number: "401-921-4968",
  },
  GLBTQDomesticViolenceProject: {
    title: "GLBTQ Domestic Violence Project",
    website: "http://www.glbtqdvp.org/our-work/domestic-violence/",
    number: "(800) 832-1901",
  },
  GLAD: {
    title: "Glad (Legal Advice and Referrals)",
    website: "http://www.glad.org/",
    number: "(617) 426-1350 Boston",
  },
  youthPrideInc: {
    title: "Youth Pride Inc",
    website: "http://www.youthprideri.org/",
    number: "(401) 421-5626",
    info:
      "Support, counseling, social and activity groups, peer education, emergency services for lesbian, gay, bisexual, transgender, queer & questioning youth",
  },
  relay: {
    title: "Relay (difficulty speaking or deaf)",
    website: "http://www.cdhh.ri.gov/resources/advocacy-legal-rights/relay.php",
    number: "(800) 745-6575",
  },
  NSPL: {
    title: "National Suicide Prevention Lifeline",
    website: "http://www.suicidepreventionlifeline.org",
    number: "1–800–273–TALK (8255) [24/7 hotline] ",
    number2: "1–888–628–9454 (Spanish)",
    number3: "1–800–799–4889 (TTY) ",
  },
};
